export const supertagTok = ['d29b3be8f2cc9a1a7051', '20028716136f69533e19'];